module.exports = __webpack_public_path__ + "b56a0002978f1aeffac831f124570bac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/RealtorLanding/RealtorsLogos/samaria-real-estate.png
// module id = 3179
// module chunks = 0